import React from 'react';
import { UnstyledButton, Group, Flex, Avatar } from '@mantine/core';
import { Link } from 'react-router-dom';

import LogoutButton from '@components/Auth/LogoutButton';

export default function Nameplate({ title = 'Admin', avatarUrl = null }) {
  const initials = getFirstLetters(title);

  return (
    <Group>
      <UnstyledButton component={Link} to="/profile">
        <Flex gap="xs" align="center">
          <Avatar
            size={40}
            radius="100%"
            color="var(--brand-brick)"
            src={avatarUrl}
          >
            {avatarUrl === null && initials}
          </Avatar>
        </Flex>
      </UnstyledButton>
      <LogoutButton />
    </Group>
  );
}

function getFirstLetters(str) {
  if (!str) return 'FS';

  return str
    .split(' ')
    .map((word) => word[0])
    .join('');
}
